import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import MfaChallengeRoute from "./MfaChallengeRoute";
import MfaSetupRoute from "./MfaSetupRoute";
import LoginRoute from "./LoginRoute";
import SetPasswordRoute from "./SetPasswordRoute";
import SignupRoute from "./SignupRoute";
import { Navigate } from "react-router-dom";
import RequireAuth from "@/components/auth/RequireAuth";
import RequireProductAccess from "@/components/auth/RequireProductAccess";
import RequireRole from "@/components/auth/RequireRole";
import RootRedirect from "@/components/auth/RootRedirect";
import { USER_ROLES } from "@/constants/auth";
import { CONTRACTS_ALLOWED_ROLES } from "@/router/routeAccess";
import MainNavigation from "@/components/navigations/MainNavigation";
import DashboardLayout from "@/layouts/DashboardLayout";
import RootLayout from "@/layouts/RootLayout";
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage";
import SetPasswordPage from "@/pages/auth/SetPasswordPage";
import MfaChallengePage from "@/pages/auth/mfa/MfaChallengePage";
import MfaSetupPage from "@/pages/auth/mfa/MfaSetupPage";
import ApiKeysPage from "@/pages/dashboard/ApiKeysPage";
import AuditLogsPage from "@/pages/dashboard/AuditLogsPage";
import ChangelogsPage from "@/pages/dashboard/ChangelogsPage";
import ContractsPage from "@/pages/dashboard/ContractsPage";
import DashboardPage from "@/pages/dashboard/DashboardPage";
import InvoicesPage from "@/pages/dashboard/InvoicesPage";
import OrganizationPage from "@/pages/dashboard/OrganizationPage";
import UsagePage from "@/pages/dashboard/UsagePage";
import ErrorPage from "@/pages/error/ErrorPage";
import UtilizationDeepDivePage from "../pages/dashboard/UtilizationDeepDivePage";
import { ClusterPage } from "@libs/appliance_ui_pages";
import LoginPage from "@/pages/login/LoginPage";
import MarketplaceRedirectPage from "@/pages/marketplace/MarketplaceRedirectPage";
import PageNotFound from "@/pages/notFound/PageNotFound";
import SignupPage from "@/pages/signup/signupPage";
import TrialPage from "@/pages/trial/TrialPage";
import { HOME_PAGE, LOGIN_PAGE, SIGNUP_PAGE, FORGOT_PASSWORD_PAGE, TRIAL_PAGE, TRIAL_SIGNUP_PAGE, TRIAL_SIGNUP_ENTROPY_PAGE, SET_PASSWORD_PAGE, MFA_CHALLENGE_PAGE, MFA_SETUP_PAGE, MARKETPLACE_REDIRECT_PAGE, DASHBOARD_PAGE, API_KEYS_PAGE, CLUSTERS_PAGE, CONTRACTS_PAGE, USAGE_PAGE, UTILIZATION_DEEP_DIVE_PAGE, INVOICES_PAGE, AUDIT_LOGS_PAGE, CHANGELOGS_PAGE, ORGANIZATION_PAGE, CONTACT_PAGE, POSTS_PAGE, POST_PAGE } from "./paths";
// Re-export path constants for backward compatibility
// Prefer importing directly from "@/router/paths" to avoid pulling in the full route tree
export { HOME_PAGE, LOGIN_PAGE, SIGNUP_PAGE, FORGOT_PASSWORD_PAGE, TRIAL_PAGE, TRIAL_SIGNUP_PAGE, TRIAL_SIGNUP_ENTROPY_PAGE, SET_PASSWORD_PAGE, MFA_CHALLENGE_PAGE, MFA_SETUP_PAGE, MARKETPLACE_REDIRECT_PAGE, DASHBOARD_PAGE, API_KEYS_PAGE, CLUSTERS_PAGE, CONTRACTS_PAGE, USAGE_PAGE, UTILIZATION_DEEP_DIVE_PAGE, INVOICES_PAGE, AUDIT_LOGS_PAGE, CHANGELOGS_PAGE, ORGANIZATION_PAGE, CONTACT_PAGE, POSTS_PAGE, POST_PAGE };
// export const routes: RouteObject[] = [
//   {
//     path: HOME_PAGE,
//     element: <RootLayout />,
//     children: [
//       {
//         path: LOGIN_PAGE,
//         element: <LoginPage />,
//       },
//       {
//         path: SIGNUP_PAGE,
//         element: (
//           <SignupRoute>
//             <SignupPage />
//           </SignupRoute>
//         ),
//       },
//       {
//         path: HOME_PAGE,
//         element: (
//           <AdminRoute>
//             <HomePage />
//           </AdminRoute>
//         ),
//       },
//       {
//         path: DASHBOARD_PAGE,
//         element: (
//           <AdminRoute>
//             <DashboardPage />
//           </AdminRoute>
//         ),
//         errorElement: <ErrorPage />,
//       },
//       {
//         path: POSTS_PAGE,
//         element: (
//           <LoggedInRoute>
//             <PostsPage />
//           </LoggedInRoute>
//         ),
//         loader: postsLoader,
//       },
//       {
//         path: POST_PAGE,
//         errorElement: <ErrorPage />,
//         element: (
//           <LoggedInRoute>
//             <PostDetails />
//           </LoggedInRoute>
//         ),
//         loader: postDetailsLoader,
//       },
//     ],
//   },
//   {
//     path: '*',
//     element: (
//       <>
//         <MainNavigation />
//         <PageNotFound />
//       </>
//     ),
//   },
// ];
export const routes = [
    // w/o header
    {
        path: HOME_PAGE,
        element: /*#__PURE__*/ _jsx(RootLayout, {}),
        children: [
            {
                path: LOGIN_PAGE,
                element: /*#__PURE__*/ _jsx(LoginRoute, {
                    children: /*#__PURE__*/ _jsx(LoginPage, {})
                })
            },
            {
                path: SIGNUP_PAGE,
                element: /*#__PURE__*/ _jsx(SignupRoute, {
                    children: /*#__PURE__*/ _jsx(SignupPage, {})
                })
            },
            {
                path: FORGOT_PASSWORD_PAGE,
                element: /*#__PURE__*/ _jsx(ForgotPasswordPage, {})
            },
            {
                path: SET_PASSWORD_PAGE,
                element: /*#__PURE__*/ _jsx(SetPasswordRoute, {
                    children: /*#__PURE__*/ _jsx(SetPasswordPage, {})
                })
            },
            {
                path: MARKETPLACE_REDIRECT_PAGE,
                element: /*#__PURE__*/ _jsx(MarketplaceRedirectPage, {})
            },
            {
                path: TRIAL_PAGE,
                element: /*#__PURE__*/ _jsx(TrialPage, {})
            },
            {
                path: TRIAL_SIGNUP_PAGE,
                element: /*#__PURE__*/ _jsx(Navigate, {
                    to: TRIAL_PAGE,
                    replace: true
                })
            },
            {
                path: TRIAL_SIGNUP_ENTROPY_PAGE,
                element: /*#__PURE__*/ _jsx(Navigate, {
                    to: TRIAL_PAGE,
                    replace: true
                })
            },
            {
                path: MFA_CHALLENGE_PAGE,
                element: /*#__PURE__*/ _jsx(MfaChallengeRoute, {
                    children: /*#__PURE__*/ _jsx(MfaChallengePage, {})
                })
            },
            {
                path: MFA_SETUP_PAGE,
                element: /*#__PURE__*/ _jsx(MfaSetupRoute, {
                    children: /*#__PURE__*/ _jsx(MfaSetupPage, {})
                })
            }
        ]
    },
    // w/ header
    {
        path: HOME_PAGE,
        element: /*#__PURE__*/ _jsx(DashboardLayout, {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ _jsx(RootRedirect, {})
            },
            {
                path: DASHBOARD_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(RequireProductAccess, {
                        children: /*#__PURE__*/ _jsx(DashboardPage, {})
                    })
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: API_KEYS_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(RequireProductAccess, {
                        children: /*#__PURE__*/ _jsx(ApiKeysPage, {})
                    })
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: CLUSTERS_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(ClusterPage, {})
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: CONTRACTS_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(RequireRole, {
                        allowedRoles: CONTRACTS_ALLOWED_ROLES,
                        children: /*#__PURE__*/ _jsx(ContractsPage, {})
                    })
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: USAGE_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(RequireProductAccess, {
                        children: /*#__PURE__*/ _jsx(UsagePage, {})
                    })
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: UTILIZATION_DEEP_DIVE_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(RequireProductAccess, {
                        children: /*#__PURE__*/ _jsx(UtilizationDeepDivePage, {})
                    })
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: INVOICES_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(RequireProductAccess, {
                        children: /*#__PURE__*/ _jsx(InvoicesPage, {})
                    })
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: AUDIT_LOGS_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(RequireProductAccess, {
                        children: /*#__PURE__*/ _jsx(RequireRole, {
                            allowedRoles: [
                                USER_ROLES.ADMIN,
                                USER_ROLES.VIEWER,
                                USER_ROLES.SUPERADMIN
                            ],
                            children: /*#__PURE__*/ _jsx(AuditLogsPage, {})
                        })
                    })
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: CHANGELOGS_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(ChangelogsPage, {})
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            },
            {
                path: ORGANIZATION_PAGE,
                element: /*#__PURE__*/ _jsx(RequireAuth, {
                    children: /*#__PURE__*/ _jsx(OrganizationPage, {})
                }),
                errorElement: /*#__PURE__*/ _jsx(ErrorPage, {})
            }
        ]
    },
    {
        path: "*",
        element: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(MainNavigation, {}),
                /*#__PURE__*/ _jsx(PageNotFound, {})
            ]
        })
    }
];
